var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import { Modal, Form, Input, Select, Switch, InputNumber, DatePicker, Radio, Divider, TreeSelect, } from "antd";
// 导入 ValidateMessages 类型
// import type { ValidateMessages } from 'rc-field-form/lib/interface';
var Option = Select.Option;
var TextArea = Input.TextArea;
var RadioGroup = Radio.Group;
/**
 * 通用表单模态框组件
 */
var GenericModalForm = function (_a) {
    var title = _a.title, visible = _a.visible, _b = _a.width, width = _b === void 0 ? 600 : _b, formItems = _a.formItems, formRef = _a.formRef, _c = _a.initialValues, initialValues = _c === void 0 ? {} : _c, onCancel = _a.onCancel, onSubmit = _a.onSubmit, _d = _a.okText, okText = _d === void 0 ? "确定" : _d, _e = _a.cancelText, cancelText = _e === void 0 ? "取消" : _e, formProps = _a.formProps, modalProps = _a.modalProps, validateMessages = _a.validateMessages, _f = _a.layout, layout = _f === void 0 ? "horizontal" : _f, // 默认为水平布局，label 在左侧
    _g = _a.labelCol, // 默认为水平布局，label 在左侧
    labelCol = _g === void 0 ? { span: 6 } : _g, // 默认标签宽度
    _h = _a.wrapperCol, // 默认标签宽度
    wrapperCol = _h === void 0 ? { span: 18 } : _h;
    var form = Form.useForm()[0];
    // 将表单实例传递给父组件
    // 优化表单实例传递
    useEffect(function () {
        if (formRef && form) {
            // 添加调试日志
            console.log("传递表单实例到父组件");
            formRef(form);
        }
    }, [form, formRef]);
    // 使用ref跟踪表单是否已经初始化
    var formInitializedRef = useRef(false);
    // 当visible或initialValues变化时重置表单
    useEffect(function () {
        if (visible) {
            // 安全处理 initialValues，确保不是 null 或 undefined
            var safeInitialValues = initialValues || {};
            // 如果有初始值，设置表单值
            if (Object.keys(safeInitialValues).length > 0) {
                form.setFieldsValue(safeInitialValues);
                formInitializedRef.current = true;
            }
            else if (!formInitializedRef.current) {
                // 只有在表单未初始化时才重置和清空
                form.resetFields();
                // 确保表单完全清空 - 添加正确的类型注解
                var emptyValues_1 = {}; // 修改此处添加类型
                formItems.forEach(function (item) {
                    // 确保item.name是字符串类型
                    if (typeof item.name === "string") {
                        emptyValues_1[item.name] = undefined;
                    }
                });
                form.setFieldsValue(emptyValues_1);
                formInitializedRef.current = true;
            }
            // 调试日志已移除
        }
        else {
            // 当模态框关闭时，重置初始化标志
            formInitializedRef.current = false;
        }
    }, [visible, initialValues, form, formItems]);
    // 渲染表单控件
    // 修改 renderFormItem 函数以添加对 treeSelect 类型的支持
    // 渲染表单控件
    var renderFormItem = function (item) {
        var type = item.type, options = item.options, _a = item.props, props = _a === void 0 ? {} : _a;
        switch (type) {
            case "input":
                return _jsx(Input, __assign({}, props));
            case "textarea":
                return _jsx(TextArea, __assign({ rows: 4 }, props));
            case "select":
                return (_jsx(Select, __assign({}, props, { children: options === null || options === void 0 ? void 0 : options.map(function (opt) { return (_jsx(Option, __assign({ value: opt.value }, { children: opt.label }), opt.value)); }) })));
            case "treeSelect":
                return (_jsx(TreeSelect, __assign({ showSearch: true, style: { width: "100%" }, dropdownStyle: { maxHeight: 400, overflow: "auto" }, placeholder: "\u8BF7\u9009\u62E9", allowClear: true, treeDefaultExpandAll: true, treeNodeFilterProp: "title" }, props)));
            case "switch":
                return _jsx(Switch, __assign({}, props));
            case "number":
                return _jsx(InputNumber, __assign({ style: { width: "100%" } }, props));
            case "date":
                return _jsx(DatePicker, __assign({ style: { width: "100%" } }, props));
            case "radio":
                return (_jsx(RadioGroup, __assign({}, props, { children: options === null || options === void 0 ? void 0 : options.map(function (opt) { return (_jsx(Radio, __assign({ value: opt.value }, { children: opt.label }), opt.value)); }) })));
            case "custom":
                var CustomComponent = item.customComponent;
                return CustomComponent ? (_jsx(CustomComponent, __assign({}, props))) : (_jsx(Input, __assign({}, props)));
            default:
                return _jsx(Input, __assign({}, props));
        }
    };
    // 根据布局模式准备表单属性
    var layoutFormProps = __assign({ layout: layout }, (layout === "horizontal" ? { labelCol: labelCol, wrapperCol: wrapperCol } : {}));
    return (_jsx(Modal, __assign({ title: title, open: visible, width: width, onCancel: onCancel, onOk: function () {
            form
                .validateFields()
                .then(function (values) { return __awaiter(void 0, void 0, void 0, function () {
                var result, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, Promise.resolve(onSubmit(values))];
                        case 1:
                            result = _a.sent();
                            // 关闭模态框(无论返回结果如何，除非返回明确的 false)
                            if (result !== false) {
                                onCancel();
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error("表单提交失败:", error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (info) {
                console.log("表单验证失败:", info);
            });
        }, okText: okText, cancelText: cancelText, destroyOnClose: true }, modalProps, { children: _jsx(Form, __assign({ form: form, initialValues: initialValues, validateMessages: validateMessages, autoComplete: "off", onFinish: onSubmit }, layoutFormProps, formProps, { style: {
                margin: "32px",
                display: visible ? "block" : "none",
            } }, { children: formItems.map(function (item) {
                // 处理分隔线类型
                if (item.type === "divider") {
                    return (_jsx(Divider, __assign({ orientation: "left", style: { marginTop: 24, marginBottom: 16 } }, { children: _jsx("span", __assign({ style: { fontWeight: "bold" } }, { children: item.label })) }), item.name));
                }
                // 处理普通表单项
                return (_jsx(Form.Item, __assign({ name: item.name, label: item.label, rules: item.rules, valuePropName: item.type === "switch" ? "checked" : "value", hidden: item.hidden === true, dependencies: item.dependencies }, { children: renderFormItem(item) }), item.name));
            }) })) })));
};
export default GenericModalForm;
